import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Settings from "./services/settings";
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={Settings.get("google_clientid")}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// if (navigator && navigator.serviceWorker) {
//   navigator.serviceWorker.register('insider/insider-sw-sdk.js');
// }